let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2JzyM")).then(() => parcelRequire('ifLKl'));